<template>
  <div id="topbar">
    <div>
       <div id="logo"><img id="logo-img" src="@/assets/images/logo.png" alt="logo"></div>
    </div>

    <currency-select id="currency"></currency-select>
  </div>
</template>

<style lang="scss" scoped>
#topbar {
  background: linear-gradient($orange2, $orange1);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0px 20px 0px;
  margin-bottom: 20px;
   @include respond(desktop-sm) {
     flex-direction:column;
  }
}

#logo {
  color: $orange;
  background: $white;
  opacity:0.8;
  border-radius: 30px;
  padding: 0px 10px 0px 10px;
  font-size: 30px;
  font-weight: bold;
  @include respond(desktop-sm) {
    margin:0px 0px 20px 0px;
  }
  @include respond(phone-only) {
    font-size: 20px;
  }
}

#logo-img {
  width:300px;
  margin:5px 0px 0px 0px;
}

#highlight {
  color: $green1;
  font-size:16px;
  font-style:italic;
   @include respond(phone-only) {
    font-size: 14px;
  }
}
</style>

<script>
import CurrencySelect from "@/components/Shared/CurrencySelect";
export default {
  components: {
    CurrencySelect,
  },
};
</script>